import { useDispatch, useSelector } from "react-redux";

// Actions
import { openViewCampaignTargetGroupForm } from "../../actions/campaign/CampaignActions";

// Constants and Utils
import { FormDataTargets } from "../../constants/GeneralConstants";

// Components
import CampaignTgViewForm from "./CampaignTgViewForm";

/**
 * Campaign Tg View Button
 */
export default function CampaignTgViewButton({
  selectedTgData = {},
  className = "",
}) {
  const dispatch = useDispatch();

  // Campaign TG View Form
  const openCampaignTgModal = useSelector(
    (state) => state.campaign.openCampaignTgModal
  );

  return (
    <>
      <div className="mx-4">
        <span
          className={`btn-link cursor-pointer mb-0 ${className}`}
          data-toggle="modal"
          data-target={`#${FormDataTargets.campaignTargetGroupViewForm}`}
          onClick={() => dispatch(openViewCampaignTargetGroupForm())}
        >
          View Target Group
        </span>
      </div>

      {/* campaign TG Form */}
      {openCampaignTgModal && (
        <CampaignTgViewForm selectedTgData={selectedTgData} />
      )}
    </>
  );
}
